import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import Hero from '../components/home/Hero';
import PainPoints from '../components/home/PainPoints';
import TrustSection from '../components/home/TrustSection';
import FrameworkPreview from '../components/home/FrameworkPreview';
import MethodologySection from '../components/home/MethodologySection';
import BookSection from '../components/home/BookSection';
import PathwaySection from '../components/home/PathwaySection';
import SEO from '../components/common/SEO';

const Home = () => {
  return (
    <MainLayout>
      <SEO 
        title="AI Implementation Partner for Social Impact"
        description="Helping leaders implement AI across their organisation without losing what makes them human. Practical, human-led strategy for social impact organisations."
        canonical="/"
      />
      
      {/* 1. Hero */}
      <Hero />
      
      {/* 2. Problem Section */}
      <PainPoints />
      
      {/* 3. Why AI CoLab Studio (Trust) */}
      <TrustSection />
      
      {/* 4. SAFE AI Framework */}
      <FrameworkPreview />
      
      {/* 5. Methodology (Leadership before technology) */}
      <MethodologySection />
      
      {/* 6. Book */}
      <BookSection />
      
      {/* 7. Final CTA (Pathway) */}
      <PathwaySection />
      
    </MainLayout>
  );
};

export default Home;